import { render, staticRenderFns } from "./CampaignDeleteDialog.vue?vue&type=template&id=47299833&"
import script from "./CampaignDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./CampaignDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports